import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { ShareModalTypes } from "../../../../../interfaces/hooks/IUseShareModalTexts";

type ShareContextType = {
  state: ShareState;
  dispatch: Dispatch<ShareState>;
};

type ShareState = {
  modal?: React.ReactNode[];
  type?: ShareModalTypes;
};

const ShareContext = createContext<ShareContextType | undefined>(undefined);

const shareProviderInitialState: ShareState = {
  modal: [],
  type: null,
};

const shareProviderReducer = (
  state: ShareState,
  newState: ShareState,
): ShareState => {
  return {
    modal: newState.modal ?? state.modal,
    type: newState.type ?? state.type,
  };
};

export const ShareProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(
    shareProviderReducer,
    shareProviderInitialState,
  );

  return (
    <ShareContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <div className={"relative z-30"}>
        {children}
        {state.modal.map((modal) => modal)}
      </div>
    </ShareContext.Provider>
  );
};

export const useShareContext = () => {
  const context = useContext(ShareContext);

  if (!context) {
    throw new Error(
      "useShareContext must be used within a ListingShareProvider",
    );
  }

  return context;
};
